module.exports = __webpack_public_path__ + "img/Porto Apartment - 84 of 85.a2a622b8.jpeg";